/* ============================================================================
   rcds-vehicle-swap.js — vehicle tiles refresh the results IN PLACE.

   WHY THIS EXISTS
   The "Select your vehicle" tiles link to a per-wheelbase collection
   (/collections/ford-transit-130-wb-low-roof). A plain click is a full document
   navigation: white flash, header/hero/FAQ all re-parsed, scroll position lost.
   That reads as dated. This swaps ONLY the results section and pushes the URL,
   so the page refreshes without reloading.

   WHY NOT CLIENT-SIDE FACET FILTERING (the obvious cheaper option)
   Measured on /collections/ford 2026-08-12: the grid renders 24 of 38 products
   (pagination) and the product facet tags do not line up with the per-wheelbase
   collections. Filtering the DOM for wb-130 + roof-low matched 1 card while the
   linked collection holds 20. Every combination was short (1 vs 20, 2 vs 22,
   1 vs 21, 2 vs 24, 3 vs 23). In-place facet filtering would therefore SHOW THE
   WRONG PRODUCTS — worse than the reload it replaces. Shopify's Section
   Rendering API returns the real collection (verified: 20 cards, "20 products"),
   so we fetch that instead.

   PROGRESSIVE ENHANCEMENT
   The tile stays a real <a href>. No JS, a crawler, a middle-click or a
   cmd/ctrl-click all get normal navigation. Only a plain left-click is
   intercepted. Any fetch failure falls through to normal navigation.
   ============================================================================ */
(function () {
  if (window.__rcdsVehicleSwap) return;          // guarded singleton
  window.__rcdsVehicleSwap = true;

  var SECTION_SEL = '.rcds-collection-main-wrap, [id^="shopify-section-"][id$="__main"]';
  var RESULTS_ANCHOR = '#rcds-results';

  function sectionEl() { return document.querySelector(SECTION_SEL); }

  function sectionId(el) {
    return el && el.id ? el.id.replace(/^shopify-section-/, '') : null;
  }

  function setBusy(on) {
    var el = sectionEl();
    if (!el) return;
    el.setAttribute('aria-busy', on ? 'true' : 'false');
    el.style.opacity = on ? '0.45' : '';
    el.style.transition = 'opacity .18s ease';
  }

  function markActive(url) {
    var path = url.split('?')[0];
    [].slice.call(document.querySelectorAll('.rcds-vehrail__card')).forEach(function (c) {
      var on = (c.getAttribute('href') || '').split('?')[0] === path;
      c.classList.toggle('is-active', on);
      if (on) { c.setAttribute('aria-current', 'true'); }
      else { c.removeAttribute('aria-current'); }
    });
  }

  // Replace the results section with the same section rendered for another collection.
  function swap(url, push) {
    var host = sectionEl();
    var sid = sectionId(host);
    if (!host || !sid) return false;

    setBusy(true);
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The section endpoint returns the section wrapper itself; take its inner markup.
        var incoming = doc.querySelector(SECTION_SEL) || doc.body.firstElementChild;
        if (!incoming) throw new Error('no section in response');
        // innerHTML is safe here BY SOURCE: the markup is our own theme section,
        // fetched SAME-ORIGIN from Shopify's Section Rendering API. It is never user
        // input. Product copy inside it is merchant-authored and already escaped by
        // Liquid. This is Shopify's documented pattern for swapping a section.
        host.innerHTML = incoming.innerHTML;

        if (push) history.pushState({ rcdsVehicle: url }, '', url);
        markActive(url);
        setBusy(false);

        // Re-arm the facet engine over the freshly injected cards.
        if (typeof window.rcdsFacetsInit === 'function') { try { window.rcdsFacetsInit(); } catch (e) {} }
        document.dispatchEvent(new CustomEvent('rcds:results-swapped', { detail: { url: url } }));

        var anchor = document.querySelector(RESULTS_ANCHOR) || host;
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      })
      .catch(function () {
        setBusy(false);
        window.location.href = url;              // hard fallback, never strand the user
      });

    return true;
  }

  document.addEventListener('click', function (e) {
    // Respect every "open somewhere else" gesture.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest ? e.target.closest('.rcds-vehrail__card') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) !== '/' || a.target === '_blank') return;
    if (!sectionEl()) return;                    // no results section on this page: let it navigate

    if (swap(href, true)) e.preventDefault();
  }, false);

  window.addEventListener('popstate', function (ev) {
    if (ev.state && ev.state.rcdsVehicle) swap(ev.state.rcdsVehicle, false);
  });

  // Reflect the current URL on first paint (deep link straight to a wheelbase).
  markActive(location.pathname);
})();
